import { Directive, HostListener, HostBinding, ElementRef, Input, Renderer2 } from '@angular/core';

@Directive({
	selector: '[hoverDropdown]',
	
})
export class DropdownHoverDirective {
	constructor(
		private elementRef: ElementRef,
		private renderer2: Renderer2) { }
	@HostBinding('class.open') isOpen = false;
	outsideClickListener: Function;

	@HostListener('click', ["$event"])
	onClick($event) {
		var hasActionClass = $event.target.classList.contains('has-action');
		if ($event.target['tagName'].toLowerCase() == "a" || hasActionClass) {
			if (!$event.target['href'] && !hasActionClass) {
				$event.stopPropagation();
			}
		} else {
			$event.stopPropagation();
		}
		this.onMouseLeave();
	}

	@HostListener('mouseenter')
	onMouseEnter() {
		this.isOpen = true;
		this.outsideClickListener = this.renderer2.listen('document', 'mousedown', ($event) => {
			this.handleEventMouseDown($event);
		});

		this.renderer2.setStyle(this.elementRef.nativeElement.querySelector('ul'), 'display', 'block');
	}

	@HostListener('mouseleave')
	onMouseLeave() {
		this.isOpen = false;
		this.outsideClickListener();
		this.renderer2.setStyle(this.elementRef.nativeElement.querySelector('ul'), 'display', 'none');
	}

	handleEventMouseDown($event) {
		if (!this.isOpen && this.outsideClickListener) {
			this.outsideClickListener();
		}
		let eventTriggeredInsideHost = this.eventTriggeredInsideHost($event);
		if (this.isOpen && !eventTriggeredInsideHost) {
			this.isOpen = false; 
			this.renderer2.setStyle(this.elementRef.nativeElement.querySelector('ul'), 'display', 'none');
		}
	}
	eventTriggeredInsideHost( event ) {
		var current = event.target;
		var host = this.elementRef.nativeElement;

		do {
			if ( current === host ) {
				return( true );
			}
			current = current.parentNode;
		} while ( current );
		return( false );
	}
	ngOnDestroy() {
		if (this.outsideClickListener) {
			this.outsideClickListener();
		}
	}
}